import { render, staticRenderFns } from "./dispatchUnreciveOrder.vue?vue&type=template&id=6ef39307&scoped=true&"
import script from "./dispatchUnreciveOrder.vue?vue&type=script&lang=js&"
export * from "./dispatchUnreciveOrder.vue?vue&type=script&lang=js&"
import style0 from "./dispatchUnreciveOrder.vue?vue&type=style&index=0&id=6ef39307&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef39307",
  null
  
)

export default component.exports